module.exports = __webpack_public_path__ + "static/media/roleExample.996c6bff.png";